import { FaStar } from "react-icons/fa";
import { AvatarCircles } from "./magicui/avatar-circles";
import Image from "next/image";

const avatars = [
  {
    imageUrl:
      "https://ph-avatars.imgix.net/3525522/7d586c15-0930-4557-8bdb-d0f557dd730e.jpeg?auto=compress&codec=mozjpeg&cs=strip&auto=format&w=120&h=120&fit=crop&frame=1&dpr=1",
    profileUrl: "https://www.extensionfast.com/#reviews",
  },
  {
    imageUrl:
      "https://ph-avatars.imgix.net/7113572/0f090584-bb74-433e-8439-5df56000682c.jpeg?auto=compress&codec=mozjpeg&cs=strip&auto=format&w=120&h=120&fit=crop&frame=1&dpr=1",
    profileUrl: "https://www.extensionfast.com/#reviews",
  },
  {
    imageUrl:
      "https://ph-avatars.imgix.net/7973597/c6693112-8cae-4a05-a273-f41c06ae6c23.png?auto=compress&codec=mozjpeg&cs=strip&auto=format&w=120&h=120&fit=crop&frame=1&dpr=1",
    profileUrl: "https://www.extensionfast.com/#reviews",
  },
  {
    imageUrl:
      "https://ph-avatars.imgix.net/8192716/original.jpeg?auto=compress&codec=mozjpeg&cs=strip&auto=format&w=120&h=120&fit=crop&frame=1&dpr=1",
    profileUrl: "https://www.extensionfast.com/#reviews",
  },
];

export function AvatarRating() {
  return (
    <div className="flex gap-x-2 justify-center items-center">
      <AvatarCircles avatarUrls={avatars} />
      <div className="flex flex-col">
        {/* Stars */}
        <div className="flex mb-2 text-yellow-500">
          <Image
            src={"/images/general/5-stars.webp"}
            width={100}
            height={100}
            alt={"5 stars lined up"}
          />
        </div>
        <div className="flex justify-center items-center gap-x-1.5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-badge-check-icon lucide-badge-check text-primary"
          >
            <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
            <path d="m9 12 2 2 4-4" />
          </svg>{" "}
          <p className="font-bold text-zinc-400">Rated 4.8/5 by builders</p>
        </div>
      </div>
    </div>
  );
}
